<template>
  <div
    class="imageInput"
    :class="{ '--vertical': fileType == 'verticalThumbnail' }"
    @click="handleClick()"
    @drop="handleFileDrop"
    @dragover="handleDragOver"
    :style="{ backgroundImage: value ? 'url(' + value.dataUrl + ')' : null }"
  >
    <div class="info">
      <span v-if="label">{{ label }}</span>
      <span class="text-danger" v-if="error || internalError"
        >{{ error }} {{ internalError }}</span
      >
    </div>

    <input type="file" ref="file" hidden @change="handleFileUpload" />
  </div>
</template>

<script>
import { compressImage } from "@/services/image";

export default {
  name: "ImageInput",
  props: ["fileType", "error", "value"],
  emits: ["change"],
  data() {
    return {
      internalError: "",
    };
  },

  methods: {
    handleClick() {
      this.$refs.file.click();
    },

    handleFileUpload(e) {
      let file = e.target && e.target.files ? e.target.files[0] : e.dataTransfer.files[0];

      let compressConfig;
      if (this.fileType == "horizontalThumbnail")
        compressConfig = { maxWidth: 1280, maxHeight: 720 };
      else if (this.fileType == "verticalThumbnail")
        compressConfig = { maxWidth: 800, maxHeight: 1200 };

      compressImage(file, compressConfig, (fileName, dataUrl) => {
        this.$emit("change", {
          name: fileName,
          dataUrl,
        });
      });

      // check image dimension
      let _URL = window.URL || window.webkitURL;
      let img = new Image();
      var objectUrl = _URL.createObjectURL(file);

      let self = this;
      img.onload = function () {
        if (
          this.width != compressConfig.maxWidth ||
          this.height != compressConfig.maxHeight
        )
          self.internalError = `Got ${this.width}x${this.height}`;
        _URL.revokeObjectURL(objectUrl);
      };
      img.src = objectUrl;
    },

    handleFileDrop(e) {
      e.preventDefault();
      this.handleFileUpload(e);
    },

    handleDragOver(e){
       e.preventDefault();
    }
  },

  computed: {
    label() {
      if (this.fileType == "horizontalThumbnail") return "Required 1280x720";
      if (this.fileType == "verticalThumbnail") return "Required 800x1200";
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.imageInput {
  height: 10rem;
  margin: 0.25rem;
  background-color: whitesmoke;
  border-radius: 0.25rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  text-align: center;
  font-size: 0.9rem;
  position: relative;
  cursor: pointer;
  flex: 1;

  &.--vertical {
    width: 8rem;
    flex: none;
  }

  .info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;

    background-color: white;
    padding: 0.25rem;
    border-radius: 0.25rem;
    opacity: 0.8;
  }
}
</style>
